/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Rating } from 'react-simple-star-rating';
import Card from '@material-ui/core/Card';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import swal from 'sweetalert';
import firebase from '../../../../config/config';
import logger from '../../../../utils/logger';
import apiCaller from '../../../../utils/apiCallerOutstanding';
import { mappedCurrentActiveRole } from '../../../../utils/roleMapping';

const useStyles = makeStyles({
  gridContainer: {
    margin: '15px 0px',
  },
  root: {
    minWidth: 275,
    textAlign: 'left',
  },
  title: { textTransform: 'capitalize', fontSize: 24 },
  titleBox: { display: 'flex', alignItems: 'center', margin: '10px 0px' },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  pos: {
    marginBottom: 12,
  },
  stars: { marginRight: '10px' },
  submitButton: {
    backgroundColor: '#3366FF',
    color: 'white',
    fontSize: '12px',
    textTransform: 'capitalize',
    padding: '5px 16px',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

export default function RatingsCard({
  activeRole,
  transactionSerial,
  currentTransactionData,
}) {
  const classes = useStyles();
  const [transporterRating, setTransporterRating] = useState(0);
  const [truckerRating, setTruckerRating] = useState(0);
  const [fetching, setFetching] = useState(false);
  const endPoint = 'pipe/rating';
  const {
    truckerId,
    transporterId,
    transporterName,
    truckerName,
  } = currentTransactionData;
  // Catch Rating value

  const role = useMemo(() => {
    if (activeRole)
      return mappedCurrentActiveRole(activeRole);
    return '';
  }, [activeRole]);

  const submitTransporterRating = async rating => {
    const currentUserDetails = firebase.auth().currentUser;
    const { Aa } = currentUserDetails;
    const userToken = Aa;

    const body = {
      transaction_serial: transactionSerial,
      source: 'transporter',
      type: 'add',
      ratings: rating,
      transporter_id: transporterId,
      role,
    };
    try {
      await apiCaller(endPoint, body, `Bearer ${userToken}`, 'nh-base', 'post');
      swal(
        'Good job!',
        `You have rated ${transporterName} Transporter!`,
        'success'
      );
    } catch (e) {
      logger.log(e);
    }
  };
  const submitTruckerRating = async rating => {
    const currentUserDetails = firebase.auth().currentUser;
    const { Aa } = currentUserDetails;
    const userToken = Aa;
    const body = {
      transaction_serial: transactionSerial,
      source: 'trucker',
      type: 'add',
      ratings: rating,
      trucker_id: truckerId,
      role,
    };
    try {
      await apiCaller(endPoint, body, `Bearer ${userToken}`, 'nh-base', 'post');
      swal('Good job!', `You have rated ${truckerName} Trucker!`, 'success');
    } catch (e) {
      logger.log(e);
    }
  };
  const resetRating = async type => {
    const currentUserDetails = firebase.auth().currentUser;
    const { Aa } = currentUserDetails;
    const userToken = Aa;
    if (type === 'trucker') {
      setTruckerRating(0);
      const body = {
        transaction_serial: transactionSerial,
        source: 'trucker',
        type: 'reset',
        trucker_id: truckerId,
        role,
      };
      try {
        await apiCaller(
          endPoint,
          body,
          `Bearer ${userToken}`,
          'nh-base',
          'post'
        );
        swal(
          'Rating reset !',
          `You have reset rating for ${truckerName} Trucker!`,
          'success'
        );
      } catch (e) {
        logger.log(e);
      }
    } else if (type === 'transporter') {
      setTransporterRating(0);
      const body = {
        transaction_serial: transactionSerial,
        source: 'transporter',
        type: 'reset',
        transporter_id: transporterId,
        role,
      };
      try {
        await apiCaller(
          endPoint,
          body,
          `Bearer ${userToken}`,
          'nh-base',
          'post'
        );
        swal(
          'Rating reset !',
          `You have reset rating for ${transporterName} Transporter!`,
          'success'
        );
      } catch (e) {
        logger.log(e);
      }
    }
  };
  const handleReset = type => {
    swal('Are you sure you want to do this?', {
      buttons: {
        cancel: 'No',
        catch: {
          text: 'Yes',
          value: type,
        },
      },
    }).then(value => resetRating(value));
  };
  const getTransactionRating = async Token => {
    const currentUserDetails = firebase.auth().currentUser;
    const { Aa } = currentUserDetails;
    const userToken = Aa;
    setFetching(true);
    const getEndPoint = `${endPoint}?role=${role}&transaction_serial=${transactionSerial}`;
    try {
      const response = await apiCaller(
        getEndPoint,
        {},
        `Bearer ${userToken}`,
        'nh-base',
        'get'
      );
      const data = response.data.body;
      setTruckerRating(parseInt(data?.trucker_rating, 10));
      setTransporterRating(parseInt(data?.transporter_rating, 10));
      setFetching(false);
    } catch (e) {
      logger.log(e);
      setFetching(false);
    }
  };
  const handleTransporterRating = async rate => {
    setTransporterRating(rate);
    await submitTransporterRating(rate);
  };
  const handleTruckerRating = rate => {
    setTruckerRating(rate);
    submitTruckerRating(rate);
  };
  useEffect(() => {
    getTransactionRating();
  }, []);
  return (
    <Grid container className={classes.gridContainer} spacing={2}>
      <Grid item xs={12} md={12} lg={3}>
        <Card className={classes.root}>
          <CardContent>
            <div className={classes.titleBox}>
              {fetching ? (
                <div
                  style={{
                    backgroundColor: 'lightgray',
                    color: 'lightgray',
                    borderRadius: '10px',
                  }}
                >
                  <Typography variant="h6" className={classes.title}>
                    Transporter Rating
                  </Typography>
                </div>
              ) : (
                <>
                  <Typography variant="h6" className={classes.title}>
                    Transporter Rating
                  </Typography>
                  {Number(transporterRating) > 0 && (
                    <CheckCircleOutlineIcon
                      style={{ marginLeft: '10px', color: 'green' }}
                      fontSize="small"
                    />
                  )}
                </>
              )}
            </div>

            <div className={classes.flex}>
              <Rating
                onClick={handleTransporterRating}
                ratingValue={transporterRating}
                initialValue={transporterRating}
                size={50}
                classNames={classes.stars}
                allowHover={activeRole === 'finance'}
                readonly={
                  activeRole === 'ops' ||
                  activeRole === 'finance-payable' ||
                  activeRole === 'finance-recievable' ||
                  activeRole === 'finance-recon' ||
                  activeRole === 'transaction-view' ||
                  currentTransactionData?.void
                }
              />
              {activeRole === 'ops' && Number(transporterRating) > 0 ? (
                <Button
                  size="small"
                  className={classes.submitButton}
                  onClick={() => handleReset('transporter')}
                >
                  Reset
                </Button>
              ) : (
                ''
              )}
            </div>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={12} lg={3}>
        <Card className={classes.root}>
          <CardContent>
            <div className={classes.titleBox}>
              {/* <Typography variant="h6" className={classes.title}>
                Trucker Rating
              </Typography>
              <CheckCircleOutlineIcon
                style={{ marginLeft: '10px', color: 'green' }}
                fontSize="small"
              /> */}
              {fetching ? (
                <div
                  style={{
                    backgroundColor: 'lightgray',
                    color: 'lightgray',
                    borderRadius: '10px',
                  }}
                >
                  <Typography variant="h6" className={classes.title}>
                    Trucker Rating
                  </Typography>
                </div>
              ) : (
                <>
                  <Typography variant="h6" className={classes.title}>
                    Trucker Rating
                  </Typography>
                  {Number(truckerRating) > 0 && (
                    <CheckCircleOutlineIcon
                      style={{ marginLeft: '10px', color: 'green' }}
                      fontSize="small"
                    />
                  )}
                </>
              )}
            </div>

            <div className={classes.flex}>
              <Rating
                onClick={handleTruckerRating}
                ratingValue={truckerRating}
                initialValue={truckerRating}
                size={50}
                classNames={classes.stars}
                allowHover={activeRole === 'finance'}
                readonly={
                  activeRole === 'ops' ||
                  activeRole === 'finance-payable' ||
                  activeRole === 'finance-recievable' ||
                  activeRole === 'finance-recon' ||
                  activeRole === 'transaction-view' ||
                  currentTransactionData?.void
                }
              />
              {activeRole === 'ops' && Number(truckerRating) > 0 ? (
                <Button
                  size="small"
                  className={classes.submitButton}
                  onClick={() => handleReset('trucker')}
                >
                  Reset
                </Button>
              ) : (
                ''
              )}
            </div>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
